export default __webpack_public_path__ + "static/media/icn-arrow.a207edef.svg";